// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T4oB","question":"styles_question__3kuRY","inputVisibleButton":"styles_inputVisibleButton__2P-g1","note":"styles_note__3m96x"};